module.exports = __webpack_public_path__ + "static/media/ado.6c31d8e3.png";